export function getVersionFromURL() {
  const env = window._ENV || "local";
  if (env === "local" && !window._NGROK_HOST) {
    throw new Error("Local environment should not be checking the url subpath");
  }

  const match = new RegExp(/\/.*\/(.*)-.*-.*-.*-.*\//g).exec(window.location.pathname);
  if (match && match.length > 1) {
    return match[1];
  }
  throw new Error(`Unable to find version in url ${window.location.pathname}`);
}
